import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import { type SelectProps } from 'ant-design-vue';
import CreateDocument from '@/components/disposable/CreateDocument.vue';
import { DocumentType } from '@/model/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateIllustrationView',
  setup(__props) {

const route = useRoute();
const authorID = route.params.authorID as string;
const sources: SelectProps['options'] = [
	{ value: '', label: 'Please select source', disabled: true },
	{ value: 'fantia', label: 'Fantia' },
	{ value: 'pixiv', label: 'Pixiv' },
	{ value: 'pixiv_fanbox', label: 'Pixiv Fanbox' },
	{ value: 'dlsite', label: 'DLSite' },
	{ value: 'fanza', label: 'Fanza (DMM)' },
	{ value: 'patreon', label: 'Patreon' }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CreateDocument, {
    "document-type": _unref(DocumentType).Illustration,
    options: sources,
    metadataID: _unref(authorID)
  }, null, 8, ["document-type", "metadataID"]))
}
}

})